import { motion } from "framer-motion";

export function FeedbackTimeoutModal({
  onNotifyMe,
  isLoading,
  onSkipAnyway,
}: {
  onNotifyMe: () => void;
  isLoading: boolean;
  onSkipAnyway?: () => void;
}) {
  return (
    <div className="absolute inset-0 flex items-end justify-center z-[5] pb-8">
      <motion.div
        initial={{ y: 80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ type: "spring", damping: 26, stiffness: 300 }}
        className="mx-4 w-full max-w-[430px] flex flex-col gap-2.5 rounded-[24px] bg-white/90 backdrop-blur-[6px] px-[18px] pt-[17px] pb-[52px]"
      >
        <p className="text-base font-semibold text-black leading-[1.5]">
          Hmm, this is taking a while
        </p>
        <p className="text-sm text-black leading-[1.3]">
          Get notified when your feedback is ready and come back when it's done. You won't lose anything.
        </p>
        <button
          onClick={onNotifyMe}
          disabled={isLoading}
          className="mt-1 w-full rounded-[27px] border border-[#b93823] px-4 py-2 text-sm font-semibold text-[#b93823] text-center disabled:opacity-60"
        >
          Notify Me
        </button>
        {onSkipAnyway && (
          <button
            onClick={onSkipAnyway}
            className="text-sm text-black/50 underline text-center"
          >
            Skip anyway
          </button>
        )}
      </motion.div>
    </div>
  );
}
